import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'replaceHlgtTag',
    standalone: false
})
export class ReplaceHlgtTagPipe implements PipeTransform {

  transform(value: string | null | undefined, ...args: unknown[]): string | null | undefined {
    if(!value) return value;

    let result = value.replaceAll("<hlgt>", "");
    result = result.replaceAll("</hlgt>", "");
    return result;
  }

}
